import { usePageWrapperData } from '@/app/common/pageWrapperProvider';
import { formatPrice } from '@/app/components/search/utils/formatting';
import useSelectedTransport from '@/app/components/hotel-detail/hooks/useSelectedTransport';
import { useUrlSearchParams } from '@/app/components/hotel-detail/UrlSearchParamsProvider';
import { useChangeTransportModal } from '@/app/components/hotel-detail/evo/transport/EvoChangeTransportCard/ChangeTransportModalProvider';
import { useChangeTransportDetailsOpenModal } from '@/app/components/hotel-detail/changeTransport/ChangeTransportDetailsModalProvider';
import { EvoTransportCard } from '@/app/components/hotel-detail/evo/transport/EvoTransportCard';

// Highlighted preselected flight, shown in the drawer while the alternatives are loading
// (MPH-469). Reuses EvoTransportCard in its isSelected variant ("Selected flight" label
// + "Keep this flight" button). Once the data arrives, the real list already includes the
// preselected one (includePreselected), so this wrapper stops rendering and there is no duplicate.
export function EvoSelectedTransportCard() {
  const { data: selectedTransportData } = useSelectedTransport();
  const selectedTransport = selectedTransportData?.transports?.[0];
  const { localization } = usePageWrapperData();
  const { isTrain } = useUrlSearchParams();
  const { closeModal } = useChangeTransportModal();
  const { openModal: openDetailsModal } = useChangeTransportDetailsOpenModal();

  if (!selectedTransport) return null;

  return (
    <div data-testid="change-flight-loading-selected">
      <EvoTransportCard
        transportId={selectedTransport.id}
        outbound={selectedTransport.outbound}
        inbound={selectedTransport.inbound}
        co2Footprint={selectedTransport.co2Footprint}
        numberOfBaggagePiecesIncluded={selectedTransport.numberOfBaggagePiecesIncluded ?? undefined}
        // This is the already selected flight: price increment 0 ("+ £0 pp" in Figma).
        price={`+ ${formatPrice({ price: 0, localization })}`}
        isTrain={isTrain}
        isEnabled={true}
        onOpenDetailsClick={() => openDetailsModal(selectedTransport)}
        // "Keep this flight": keeping the current flight = closing the drawer.
        onSelectClick={closeModal}
      />
    </div>
  );
}
